/**
 * Article × criterion pairs that have no entry in results (by _original_index + criterion_id).
 */

/**
 * @param {object[]} sampledArticles
 * @param {object[]} criteria
 * @param {object[]} results
 * @returns {Array<{ articleIndex: number, criterionIndex: number, originalIndex: string|number, criterionId: string|number, articleTitle: string, criterionLabel: string, criterionType: string }>}
 */
export function getMissingHumanScreeningPairs(sampledArticles, criteria, results) {
  if (!Array.isArray(sampledArticles) || !Array.isArray(criteria)) return []
  const answered = new Set(
    (results || []).map((r) => `${String(r?._original_index)}::${String(r?.criterion_id)}`)
  )
  const missing = []
  sampledArticles.forEach((article, articleIndex) => {
    const orig = article?._original_index ?? articleIndex
    const title = (article?.title && String(article.title).trim()) || `(Article ${articleIndex + 1})`
    criteria.forEach((criterion, criterionIndex) => {
      const critId = criterion?.id
      if (critId === undefined || critId === null) return
      const key = `${String(orig)}::${String(critId)}`
      if (answered.has(key)) return
      const critText =
        criterion.text || criterion.criterion || criterion.description || criterion.name || String(critId)
      missing.push({
        articleIndex,
        criterionIndex,
        originalIndex: orig,
        criterionId: critId,
        articleTitle: title,
        criterionLabel: critText,
        criterionType: criterion.type || "",
      })
    })
  })
  return missing
}
